export default __webpack_public_path__ + "static/931-7760b5c147f733afde88a87d17a54295.gif";